import axios from "axios";
import { getConfig } from "../config";
import { clear, getToken } from "./auth";

const config = getConfig();
export const HOST_API = `${config.baseUrl}/api/v1/`;

const axiosClient = axios.create({
  baseURL: HOST_API,
  headers: {
    "content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status) {
      if (
        error.response.status === 401 &&
        window.location.pathname !== "/login"
      ) {
        clear();
        window.location.href = "/";
      }
    }

    return new Promise((_, reject) => {
      reject(error);
    });
  }
);

const GET = (url, params = {}, isToken = false) => {
  if (isToken) {
    return axiosClient.get(url, {
      params: { ...params },
      headers: { authorization: "Bearer " + getToken() },
    });
  }

  return axiosClient.get(url, { params });
};

const DELETE = (url, params = {}, isToken = false) => {
  if (isToken) {
    return axiosClient.delete(url, {
      params,
      headers: { authorization: "Bearer " + getToken() },
    });
  }

  return axiosClient.delete(url, { params });
};

const POST = (url, payload = {}, params = {}, isToken = false) => {
  if (isToken) {
    return axiosClient.post(url, payload, {
      headers: { authorization: "Bearer " + getToken() },
      params,
    });
  }

  return axiosClient.post(url, payload, { params });
};

const FILE = (url, payload = {}, params = {}, isToken = false) => {
  if (isToken) {
    return axiosClient.post(url, payload, {
      headers: {
        authorization: "Bearer " + getToken(),
        "Content-Type": "multipart/form-data",
      },
      params,
    });
  }

  return axiosClient.post(url, payload, { params });
};

const PUT = (url, payload, params, isToken) => {
  if (isToken) {
    return axiosClient.put(url, payload, {
      headers: { authorization: "Bearer " + getToken() },
      params,
    });
  }

  return axiosClient.put(url, payload, { params });
};

const PATCH = (url, payload, params, isToken) => {
  if (isToken) {
    return axiosClient.patch(url, payload, {
      headers: { authorization: "Bearer " + getToken() },
      params,
    });
  }
  return axiosClient.patch(url, payload, { params });
};

export { DELETE, FILE, GET, PATCH, POST, PUT };

export default axiosClient;
